import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toArray, omit } from 'lodash';
import MediaQuery from 'react-responsive';

import { PATH } from '../../constants/path';
import { SUB_NAV_CATEGORIES } from '../../services/nav/constants';
import { MENU_VERSION_MENU_MOBILE_SLIDE } from '../../services/header/constants';

import { showSubNav, hideSubNav } from '../../services/nav/actions';

import LocalizedNavLink from '../router/LocalizedNavLink';
import CategoriesSubNavComponent from './CategoriesSubNavComponent';

import './NavComponent.scss';

class MenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOffline: false,
            isEbon: false
        };
    }

    toggleOffline = value => {
        this.setState({ isOffline: value });
    };
    toggleEbon = value => {
        this.setState({ isEbon: value });
    };

    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => this.showSubNav(SUB_NAV_CATEGORIES);
    onMouseLeaveCategories = () => this.hideSubNav();

    showCategories = (isOffline, isEbon) => () => {
        this.toggleOffline(isOffline);
        this.toggleEbon(isEbon);
        this.onMouseEnterCategories();
    };

    onClickCategories = (matches, isOffline, isEbon) => e => {
        if (!matches) {
            this.toggleOffline(isOffline);
            this.toggleEbon(isEbon);
            e.preventDefault();
            if (!this.props.subNavDisplayed) {
                this.showSubNav(SUB_NAV_CATEGORIES);
            } else {
                this.hideSubNav();
            }
        }
    };

    makeOnClickCategories = (matches, isOffline, isEbon) =>
        this.onClickCategories(matches, isOffline, isEbon);

    render() {
        const {
            i18n,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide,
            categories,
            location
        } = this.props;
        const { isOffline, isEbon } = this.state;

        const OnlineDirectoryUrl = `/${PATH.ONLINE}/`;
        const EbonDirectoryUrl = `/${PATH.EBON}/`;

        return (
            <nav
                className={`menu menu-mobile-slide ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : ''
                }`}
                id="menu">
                <div className="conteneur menu-conteneur flex-container-h">
                    <LocalizedNavLink to={PATH.HOME_PATH} activeClassName="actif" exact>
                        {i18n.HOME}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.HOW_IT_WORK_PATH} activeClassName="actif">
                        {i18n.HOW_IT_WORKS}
                    </LocalizedNavLink>
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_ONLINE_MOST_POPULAR_PATH}
                                className={`menu-sous-menu ${
                                    location.pathname.indexOf(OnlineDirectoryUrl) !== -1
                                        ? 'actif'
                                        : ''
                                }`}
                                onMouseEnter={this.showCategories(false, false)}
                                onMouseLeave={this.onMouseLeaveCategories}
                                onClick={this.makeOnClickCategories(matches, false, false)}>
                                {i18n.ONLINE_OFFERS}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <MediaQuery query="(max-width: 768px)">
                        {matches =>
                            matches &&
                            !isOffline &&
                            !isEbon && <CategoriesSubNavComponent categories={categories} />
                        }
                    </MediaQuery>
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                className={`menu-sous-menu ${
                                    location.pathname.indexOf(EbonDirectoryUrl) !== -1
                                        ? 'actif'
                                        : ''
                                }`}
                                onMouseEnter={this.showCategories(false, true)}
                                onMouseLeave={this.onMouseLeaveCategories}
                                onClick={this.makeOnClickCategories(matches, false, true)}>
                                {i18n.EBON_OFFERS}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <MediaQuery query="(max-width: 768px)">
                        {matches =>
                            matches &&
                            isEbon && <CategoriesSubNavComponent categories={categories} isEbon />
                        }
                    </MediaQuery>
                    <LocalizedNavLink to={PATH.TOOLBAR_PATH} activeClassName="actif">
                        {i18n.TOOLBAR}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.CONTACTREQUEST_PATH} activeClassName="actif">
                        {i18n.CONTACT}
                    </LocalizedNavLink>
                </div>
                <MediaQuery query="(min-width: 769px)">
                    {matches =>
                        matches &&
                        !isOffline &&
                        !isEbon && <CategoriesSubNavComponent categories={categories} />
                    }
                </MediaQuery>
                <MediaQuery query="(min-width: 769px)">
                    {matches =>
                        matches &&
                        isEbon && <CategoriesSubNavComponent categories={categories} isEbon />
                    }
                </MediaQuery>
            </nav>
        );
    }
}

MenuComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        i18n: state.i18n.feature.header.menu,
        categories: toArray(omit(state.category.categories, 'loading')),
        subNavDisplayed: !!state.nav.subNav,
        location: state.routing.location
    };
};

const mapDispatchToProps = {
    showSubNav,
    hideSubNav
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/NavComponent.js